export default __webpack_public_path__ + "static/media/site_logo.a08b0a0b.svg";